import { brandSecondary, darkGrayFontColor, titles } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		position: 'relative',
		width: 460,
	},
	header: {
		textAlign: 'right',
	},
	title: {
		color: brandSecondary,
		fontSize: 18,
		lineHeight: '22px',
		marginBottom: 16,
	},
	content: {
		paddingBottom: 30,
	},
	message: {
		alignItems: 'center',
		color: titles,
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: 16,
		gap: 6,
		lineHeight: '24px',
		marginBottom: 12,
	},
	subMessage: {
		color: darkGrayFontColor,
		fontSize: 14,
		lineHeight: '20px',
		marginBottom: 30,
	},
	removingMessage: {
		alignItems: 'center',
		display: 'flex',
		paddingBottom: 30,
		...CssSelectors.allDescendants(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	buttonContainer: {
		alignItems: 'center',
		display: 'flex',
		gap: 12,
		justifyContent: 'flex-end',
	},
	cancelButton: {
		minWidth: 100,
	},
	confirmButton: {
		minWidth: 150,
	},
});
